import { render } from "./App.vue?vue&type=template&id=26881e66&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=26881e66&lang=scss&scoped=true"

import exportComponent from "E:\\domains\\kbtuendowment.local\\htdocs\\wp-content\\plugins\\donation-widget\\script\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26881e66"]])

export default __exports__